var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 1.875H11.25V1.25C11.25 0.90625 10.9688 0.625 10.625 0.625C10.2812 0.625 10 0.90625 10 1.25V1.875H5V1.25C5 0.90625 4.71875 0.625 4.375 0.625C4.03125 0.625 3.75 0.90625 3.75 1.25V1.875H3.125C2.43125 1.875 1.88125 2.4375 1.88125 3.125L1.875 11.875C1.875 12.5625 2.43125 13.125 3.125 13.125H11.875C12.5625 13.125 13.125 12.5625 13.125 11.875V3.125C13.125 2.4375 12.5625 1.875 11.875 1.875ZM11.25 11.875H3.75C3.40625 11.875 3.125 11.5938 3.125 11.25V5H11.875V11.25C11.875 11.5938 11.5938 11.875 11.25 11.875ZM5 6.25H6.875C7.21875 6.25 7.5 6.53125 7.5 6.875V8.75C7.5 9.09375 7.21875 9.375 6.875 9.375H5C4.65625 9.375 4.375 9.09375 4.375 8.75V6.875C4.375 6.53125 4.65625 6.25 5 6.25Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/calendar-grey.bfcc66d2dcd0200a589e5c7a6f5940d5.svg";
export { ForwardRef as ReactComponent };